import Image from 'next/image';
import React, { ReactElement } from 'react';

import { useGetAppOrSignUpHandler } from '../../../../../hooks/useGetAppOrSignUpHandler';
import { Assets } from '../../../../../utils/assets';
import { PrimaryButtonLink } from '../../../../button';
import MaxWidth from '../../../../shared/MaxWidth';
import * as S from './Hero.styles';

export const Hero = (): ReactElement => {
  const handleClickCta = useGetAppOrSignUpHandler();

  return (
    <S.Wrapper>
      <S.Background>
        <Image
          alt={Assets.images.scienceBg.alt}
          fill
          loading="eager"
          object-fit="cover"
          priority
          src={Assets.images.scienceBg.url}
        />
      </S.Background>
      <S.BackgroundMobile>
        <Image
          alt={Assets.images.scienceBgMobile.alt}
          fill
          loading="eager"
          object-fit="cover"
          priority
          src={Assets.images.scienceBgMobile.url}
        />
      </S.BackgroundMobile>
      <MaxWidth>
        <S.Content>
          <S.TextBox>
            <S.Caption>Science you can hear</S.Caption>
            <S.Description>
              Brain.fm contains patterns that shift your brain state with entrainment. <br />
              Our music sounds different—and affects you differently—than any other music.
            </S.Description>
            <S.CtaWrapper>
              <PrimaryButtonLink
                analyticsEvent={{
                  category: 'Purple CTA',
                  action: 'Science Page: CTA Button Click',
                }}
                onClick={handleClickCta}
              >
                Feel the science yourself
              </PrimaryButtonLink>
            </S.CtaWrapper>
          </S.TextBox>
          <S.Footer>
            <Image
              alt={Assets.images.scienceFoundation.alt}
              height={64}
              loading="eager"
              priority
              src={Assets.images.scienceFoundation.url}
              width={144}
            />
            <S.FooterCaption>
              Brain.fm is supported by the National Science Foundation
            </S.FooterCaption>
          </S.Footer>
        </S.Content>
      </MaxWidth>
    </S.Wrapper>
  );
};
